import environment from "../../common/environment";
import { getResponseData } from "../../common/utils/api-utils";

/*----- API CALLS ------*/

export async function getShareCartApiCallMagento(shareCartApi: string, loggedInUsertoken: string) {
  return await getResponseData(
    new Request(environment().magentoUrl + shareCartApi.toString(), {
      method: 'GET',
      credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
            'Authorization' : `Bearer ${loggedInUsertoken}`
        },
    }));
}
